import { RatingColor } from 'constants/'

export default {
  group: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  percentage: {
    position: 'relative',
    background: '#F6F6F6',
    height: 6,
    width: '100%',
    borderRadius: 3,
    '&:after': {
      content: '""',
      position: 'absolute',
      width: ({ reviewCount, totalReview }) => `${(reviewCount / totalReview) * 100}%`,
      height: 6,
      borderRadius: 3,
      left: 0,
      top: 0,
      background: ({ color }) => color || RatingColor[3]
    }
  },
  rateAndLine: {
    display: 'flex',
    alignItems: 'center',
    width: '90%'
  },
  reviewCountPercentage: {
    width: 41
  }
}
